import { ActivatedRouteSnapshot } from '@angular/router';

import { AdaptiveLayoutState } from '@frontend/sports/layout/feature';
import { TabsGroupSizesType } from '@frontend/ui/tabsgroup';
import { BehaviorSubject, Observable } from 'rxjs';

import { SubNavigationItem } from './sub-navigation.models';

export abstract class SubNavigationResolve<TModel> {
    protected tabs$ = new BehaviorSubject<SubNavigationItem[]>([]);
    protected size$ = new BehaviorSubject<TabsGroupSizesType>('large');
    protected fullWidth$ = new BehaviorSubject<boolean>(false);

    get subNavigation$(): Observable<SubNavigationItem[]> {
        return this.tabs$.asObservable();
    }

    get tabSize$(): Observable<TabsGroupSizesType> {
        return this.size$.asObservable();
    }

    get tabFullWidth$(): Observable<boolean> {
        return this.fullWidth$.asObservable();
    }

    abstract buildSubNavigation(layout: AdaptiveLayoutState, routeSnapshot: ActivatedRouteSnapshot, model: TModel): void;

    cleanup(): void {
        this.tabs$.next([]);
    }
}
